export default "__VITE_ASSET__uJwKFGOh__"